import { render, staticRenderFns } from "./BIAnalyticsButton.vue?vue&type=template&id=2998e791&scoped=true"
import script from "./BIAnalyticsButton.vue?vue&type=script&lang=js"
export * from "./BIAnalyticsButton.vue?vue&type=script&lang=js"
import style0 from "./BIAnalyticsButton.vue?vue&type=style&index=0&id=2998e791&lang=scss&scoped=true"
import style1 from "./BIAnalyticsButton.vue?vue&type=style&index=1&id=2998e791&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2998e791",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2998e791')) {
      api.createRecord('2998e791', component.options)
    } else {
      api.reload('2998e791', component.options)
    }
    module.hot.accept("./BIAnalyticsButton.vue?vue&type=template&id=2998e791&scoped=true", function () {
      api.rerender('2998e791', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Home/BIAnalyticsButton.vue"
export default component.exports